import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { getPetitionAnglesPageData } from '#src/app/shared/api/socialStarter';

import type { SocialStarterPageData } from './types';

export async function getSocialStarterPageData(
	utilityContext: UtilityContext,
	identifier: string,
): Promise<SocialStarterPageData> {
	return getPetitionAnglesPageData(utilityContext, identifier, { requireAngles: true });
}
